"use client";

import { cn } from "@/utils/utils";
import React, { useState } from "react";
import useTranslationApi from "@/lib/hooks/useTranslationApi";

import { PromotionJson } from "@/types/Promotion.type";
import { CloseIcon, EmptyIcon } from "@/components/icons";
import TextDateTime from "@/components/TextDateTime";
import PopupDefault from "@/components/PopupDefault";
import CouponImgIcon from "@/components/icons/CouponImgIcon";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/Tooltip";
import usePromotions from "@/lib/hooks/usePromotions";
import { getPromotionValid } from "@/utils/product";
import PromotionConditionInfo from "~components/promotion/PromotionConditionInfo";
const translate = {
	product_code_promotion: "product_code_promotion",
	product_time_promotion: "product_time_promotion",
	product_promotion_name: "product_promotion_name",
	product_promotion_description: "product_promotion_description",
	product_promotion_for_you: "product_promotion_for_you",
	product_promotion_end_time: "product_promotion_end_time",
	product_promotion_condition: "product_promotion_condition",
	product_promotion_account_and_condition:
		"product_promotion_account_and_condition",
};
export default function ProductMyPromotions() {
	const { data } = usePromotions();
	const promotions = getPromotionValid(data || []);

	const { t } = useTranslationApi(Object.values(translate));

	// if (error.length) {
	//   return null;
	// }

	// if (isLoading) {
	//   return (
	//     <div className=" py-4">
	//       <LoadingTinySkeleton />
	//     </div>
	//   );
	// }

	// if (!promotions.length) {
	//   return null;
	// }

	return (
		<div className="py-4">
			<h3 className="font-bold text-base mb-2">
				{t(translate.product_promotion_for_you)}
			</h3>
			<ul className="flex flex-none overflow-auto scrollbarCustomer gap-4 mt-4 pb-2">
				{promotions.length > 0 ? (
					<>
						{promotions?.map((data) => {
							return <PromotionItem data={data} key={data.id} />;
						})}
					</>
				) : (
					<li className="mx-auto text-center flex flex-col justify-center items-center">
						<EmptyIcon className="w-10 h-10"></EmptyIcon>
						<p>Chưa có khuyến mãi</p>
					</li>
				)}
			</ul>
		</div>
	);
}

function PromotionItem({ data }: { data: PromotionJson }) {
	const { t } = useTranslationApi(Object.values(translate));
	const [open, setOpen] = useState(false);
	const [openMobile, setOpenMobile] = useState<boolean>(false);

	const renderPromotionDetail = (data: PromotionJson) => {
		return (
			<>
				<div className="grid grid-cols-2 gap-1 text-lg text-gray-500">
					<p className="mb-3 text-lg text-gray-500">
						{t(translate.product_code_promotion)} :
					</p>
					<p>{data.campaign_info.code}</p>
					<p className="mb-3 text-lg text-gray-500">
						{t(translate.product_time_promotion)} :{" "}
					</p>
					<p>
						<TextDateTime
							className="text-lg text-gray-500"
							format="HH:mm DD/MM/YYYY"
							ts={(data.start_date && Number(data.start_date)) || 0}
						/>{" "}
						-{" "}
						<TextDateTime
							className="text-lg text-gray-500"
							format="HH:mm DD/MM/YYYY"
							ts={(data.end_date && Number(data.end_date)) || 0}
						/>
					</p>
					<p className="mb-3 text-lg text-gray-500">
						{t(translate.product_promotion_name)}:
					</p>
					<p>{data.campaign_info.name}</p>
				</div>
				<PromotionConditionInfo promotion={data} />
			</>
		);
	};
	return (
		<li
			key={data.id}
			className={cn(
				"h-[100px] rounded-[8px] bg-white shadow-coupon-card border border-gray-200 flex relative min-w-[382px] overflow-hidden"
			)}>
			<CouponImgIcon className="w-[100px] h-[100px] min-w-[100px]" />
			<div className={cn("flex-1 flex flex-col justify-between p-3")}>
				<div>
					<p className="text-gray-500 font-bold text-base leading-[22.4px] line-clamp-1">
						{data.campaign_info.code && <>[{data.campaign_info.code}] </>}

						{data.campaign_info.name}
					</p>
					<p className="text-gray-400 text-xs leading-[14px] line-clamp-1">
						{data.campaign_info.description || ""}
					</p>
				</div>

				<div className="flex items-center justify-between">
					<p className="text-red-500 text-xs font-semibold flex">
						{t(translate.product_promotion_end_time)}
						{/* <Countdown format="HH:mm" initialSeconds={data?.end_date || 0} /> */}
						<TextDateTime
							ts={(data.end_date && Number(data.end_date)) || 0}
							format="HH:mm"
							className="text-red-500 text-xs font-bold ml-1"
						/>
						<span className="ml-1"> giờ</span>
					</p>
					<span
						className="md:hidden text-gray-300 underline cursor-pointer font-semibold text-[8px]"
						onClick={(e) => {
							e.stopPropagation();
							setOpenMobile(true);
						}}>
						{t(translate.product_promotion_condition)}
					</span>
					<div className="hidden md:block">
						<Tooltip placement="bottom">
							<TooltipTrigger
								onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									setOpen((pre) => !pre);
								}}>
								<span className="text-gray-300 underline cursor-pointer font-semibold text-[8px]">
									{t(translate.product_promotion_condition)}
								</span>
							</TooltipTrigger>
							<TooltipContent className="Tooltip">
								<div className="overflow-y-auto no-scrollbar w-[420px] h-[414px] bg-white rounded-lg    shadow-coupon-card p-4">
									<div className="flex">
										<h4 className="flex-1 text-center mb-3 text-gray-500">
											{t(translate.product_promotion_account_and_condition)}
										</h4>
										<div
											className="cursor-pointer flex-shrink-0 w-6 h-6 flex items-center justify-center"
											onClick={(e) => {
												e.stopPropagation();
												setOpen(false);
											}}>
											<CloseIcon />
										</div>
									</div>
									{renderPromotionDetail(data)}
								</div>
							</TooltipContent>
						</Tooltip>
					</div>
				</div>
			</div>

			<PopupDefault
				closeOnMark={false}
				open={openMobile}
				onClose={() => {
					setOpenMobile(false);
				}}
				isDrawerMobile>
				<div
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
					}}
					className="overflow-y-auto no-scrollbar min-h-[500px] max-h-[100%]">
					{renderPromotionDetail(data)}
				</div>
			</PopupDefault>
		</li>
	);
}
